import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Auth } from 'aws-amplify';
import { Modal, Button } from 'react-bootstrap';
import { getTokenForAuthentication } from '../../authentication/utils';

const UserStatusChecker = () => {
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const popupShownRef = useRef(false);
  const tokenRef = useRef(null);
  const intervalRef = useRef(null);

  const showPopupWithMessage = (message) => {
    setErrorMessage(message);
    setShowModal(true);
    popupShownRef.current = true;
  };

  const checkUserStatus = async (token) => {
    try {
      if (!sessionStorage.getItem('STATE_PARAM')) return;

      const currentSession = sessionStorage.getItem("STATE_PARAM");
      const userEmail =  currentSession ? JSON.parse(currentSession).agentEmail: '';
      const cognitoUserPool = process.env.REACT_APP_AGENT_PORTAL_USER_POOL || '';

      if (!currentSession) return;

      const response = await axios.post(
        `${process.env.REACT_APP_AUTHENTICATION_URL}v1/csrportal/getuser`,
        {
          cognitoUserPool,
          username: userEmail
        },
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
            'x-tenant-id': Buffer.from(`NETWELL;${new Date()}`).toString('base64')
          }
        }
      );

      if (response.data && response.data.errorCode) {
        setErrorMessage(response.data.message);
        setShowModal(true);
        return;
      }

      if (response.data && response.data.enabled === false) {
        setErrorMessage(
          'Your user account has been disabled. Please contact administrator.'
        );
        setShowModal(true);
      } else {
        setShowModal(false);
      }
    } catch (error) {
      if (error && error.response && error.response.data && error.response.data.message) {
        const message = String(error.response.data.message);
        if (message.toLowerCase().includes('cognitouserpool') || message.toLowerCase().includes('not found')) {

        }else{
          setErrorMessage(message);
          setShowModal(true);
        } 
      }
    }
  };



  useEffect(() => {
    let isMounted = true;

    getTokenForAuthentication()
      .then((response) => {
        if (!isMounted) return;

        const token = response.headers.authorization;
        tokenRef.current = token;

        // Initial check
        checkUserStatus(token);

        // Poll every 10 seconds
        intervalRef.current = setInterval(() => {
          if (tokenRef.current) {
            checkUserStatus(tokenRef.current);
          }
        }, 300000);
      })
      .catch((error) => {
        console.error('Error getting authentication token:', error);
      });

    return () => {
      isMounted = false;
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const handleLogout = async () => {
    try {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }

      await Auth.signOut();
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = '/';
    } catch (error) {
      console.error('Error during logout:', error);
      window.location.href = '/';
    }
  };

  return (
    <Modal show={showModal} backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>Session Alert</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {errorMessage ||
            'Your session is no longer valid. Please log in again.'}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button style={{ background: '#303192' }} onClick={handleLogout}>
          Logout
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UserStatusChecker;
